import React from 'react'
import { Responsible } from '../../../types/Responsible'
import { OscInput } from '../OscInputs/OscInput'
import { TelInput } from '../OscInputs/TelInput'


export const ResponsibleFields = ({responsible}:Props) => {

    

    return (
        <div className='grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-2 text-gray-800 mt-6 '>

            <OscInput 
                    textInfo="*Responsável legal é a pessoa física indicada no contrato ou estatuto social da organização" 
                    label={'Nome do responsável legal'} defaultValue={responsible && responsible.name} name={'responsible[0][name]'} necessary required important />

            <OscInput 
                    textInfo="*Responsável legal é a pessoa física indicada no contrato ou estatuto social da organização" 
                     label={'Email do responsável legal'}  defaultValue={responsible && responsible.email } name={"responsible[0][email]"} necessary required important />

            <TelInput 
                    textInfo="*Responsável legal é a pessoa física indicada no contrato ou estatuto social da organização" 
                    label={'Contato do responsável legal'} type={'tel'} autoComplete="false" defaultValue={responsible && responsible.phone} name={'responsible[0][phone]'} necessary required important />
              

        </div>
    )
}
interface Props
{
    responsible?:Responsible
}
